import appConfig from '../../../config/appConfig';

var purchaseSuggestionConfig = {
  apiUrl: appConfig.apiUrl + 'purchaseorders/'
};

export default purchaseSuggestionConfig;


// WEBPACK FOOTER //
// ./src/components/purchaseorders/config/purchaseOrderConfig.js